export const DIRTY_INDICATOR = '*';
//# sourceMappingURL=shared.js.map